// extracted by mini-css-extract-plugin
module.exports = {"createOrdCampaignModal":"styles_createOrdCampaignModal__1vlIE","subtitle":"styles_subtitle__2o8sk","form":"styles_form__n1RaF","createNameOrd":"styles_createNameOrd__2hCDF"};